<template>
  <div class="bg-white !shadow rounded-md py-2 px-3 text-lg">
    <div class="text-xl font-bold mb-3">Inbound</div>
    <div class="space-y-3 text-lg mb-3"
      v-if="existsTripData">
      <HighlightChange class="flex flex-row items-center gap-3"
        :changeType="tripHighlighting.vehicleCode">
        <div v-if="showRouteDetailModal">
          <RouteDetailModal
            :routeId="tripData.route_id"
            :title="`${tripData.vehicle_code} - Inbound - ${tripData.dropoff_building?.name}`"
            :date="selectedDate"
            direction="Inbound"
          />
        </div>
        <div class="font-bold">
          Vehicle Number
        </div>
        <div v-if="tripData.vehicle_code">
          <span class="text-gray-600">{{ tripData.vehicle_code }}</span>
        </div>
        <div v-else>
          <span class="text-gray-300">---</span>
        </div>
      </HighlightChange>
      <HighlightChange class="flex flex-row gap-3"
        :changeType="tripHighlighting.pickupTime">
        <div class="font-bold">
          Pickup Time
        </div>
        <div v-if="tripData.pickup_time">
          <span>{{ pickupTimeDisplay }}</span>
        </div>
        <div v-else>
          <span class="text-gray-300">---</span>
        </div>
      </HighlightChange>
      <HighlightChange class="flex flex-row items-center gap-3"
        :changeType="tripHighlighting.arrivalTime">
        <div class="font-bold">
          Arrive Time
        </div>
        <div v-if="tripData.arrival_time">
          <span>{{ arrivalTimeDisplay }}</span>
        </div>
        <div v-else>
          <span class="text-gray-300">---</span>
        </div>
      </HighlightChange>
      <div class="flex flex-row items-center gap-3">
        <div v-if="overridePickupBuilding">
          <HighlightChange
            :changeType="tripHighlighting.overridePickupBuildingDiff">
            <BuildingDisplay
              :buildingData="overridePickupBuilding"
              :buildingDataDiff="overridePickupBuildingDiff"
            />
          </HighlightChange>
        </div>
        <div v-else>
          <div v-if="tripData.pickup_bus_stop">
            <HighlightChange
              :changeType="tripHighlighting.pickupBusStop">
              <BusStopDisplay
                :busStopData="tripData.pickup_bus_stop"
              />
            </HighlightChange>
          </div>
          <div v-else>
            <HighlightChange
              :changeType="tripHighlighting.pickupAddress">
              <AddressDisplay
                type="pickup"
                :addressData="tripData.pickup_address"
              />
            </HighlightChange>
          </div>
        </div>
      </div>
      <div class="flex flex-col bg-gray-100 rounded-md items-start p-1 gap-1">
        <HighlightChange class="flex flex-row gap-3"
          :changeType="tripHighlighting.tripDropoffBuilding">
          <BuildingDisplay
            type="dropoff"
            :buildingData="tripData.trip_dropoff_building"
            :buildingDataDiff="tripDataDiff?.trip_dropoff_building"
          />
        </HighlightChange>
      </div>
    </div>
    <div class="space-y-3 text-lg mb-3"
      v-if="!existsTripData">
      None
    </div>
  </div>
</template>

<script>
import { isEmpty } from 'lodash'
import time from '../../../../services/utils/time.js'
import scheduleUtil from '../../../../services/utils/schedule.js'

import BusStopDisplay from '../BusStopDisplay.vue'
import BuildingDisplay from '../BuildingDisplay.vue'
import AddressDisplay from '../AddressDisplay.vue'

import HighlightChange from '../../utilities/HighlightChange.vue'

import RouteDetailModal from '../../../modals/RouteDetailModal.vue'


export default {
  components: {
    BusStopDisplay,
    BuildingDisplay,
    AddressDisplay,
    HighlightChange,
    RouteDetailModal,
  },
  props: {
    showRouteDetailModal: {
      type: Boolean,
      default: false,
    },
    tripData: Object,
    tripDataDiff: Object,
    overridePickupBuilding: {
      type: Object,
      default: undefined,
    },
    overrideDropoffBuildingDiff: {
      type: Object,
      default: undefined,
    },
    selectedDate: String,
  },
  computed: {
    existsTripData() {
      return !(this.tripData == undefined || isEmpty(this.tripData))
    },
    arrivalTimeDisplay() {
      return time.formatAMPM(this.tripData?.arrival_time)
    },
    pickupTimeDisplay() {
      return time.formatAMPM(this.tripData?.pickup_time)
    },
    tripHighlighting() {
      return {
        vehicleCode: scheduleUtil.mapDiffObject(this.tripDataDiff?.vehicle_code),
        arrivalTime: scheduleUtil.mapDiffObject(this.tripDataDiff?.arrival_time),
        pickupTime: scheduleUtil.mapDiffObject(this.tripDataDiff?.pickup_time),
        pickupBusStop: scheduleUtil.mapDiffObject(this.tripDataDiff?.pickup_bus_stop),
        pickupAddress: scheduleUtil.mapDiffObject(this.tripDataDiff?.pickup_address),
        tripDropoffBuilding: scheduleUtil.mapDiffObject(this.tripDataDiff?.trip_dropoff_building),
        overridePickupBuildingDiff: scheduleUtil.mapDiffObject(this.overridePickupBuildingDiff),
      }
    },
  },
}
</script>
